import React, { useState } from "react";
import { ConfirmPopup } from "../Confirmation";
import SwitchInput from "../../../common/SwitchInput";
import { toast } from "react-toastify";

export const getUserColumns = ({
  onDeleteClick,
  onEditClick,
  onStatusChange,
  onRestoreClick,
  onViewSubscriptions
}) => {
  const [confirmOpenForId, setConfirmOpenForId] = useState(null);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    } catch {
      return dateString;
    }
  };

  const getRowStyle = (row) =>
    row.isDeleted
      ? {
        opacity: 0.5,
        backgroundColor: "#f9f9f9",
      }
      : {};

  return [
    {
      name: <span className="font-weight-bold fs-13">Name</span>,
      selector: (row) => `${row.firstname || ""} ${row.lastname || ""}`.trim(),
      cell: (row) => (
        <div style={getRowStyle(row)}>
          {`${row.firstname || ""} ${row.lastname || ""}`.trim() || "-"}
        </div>
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">Email</span>,
      selector: (row) => row.email || "-",
      sortable: true,
      cell: (row) => <div style={getRowStyle(row)}>{row.email || "-"}</div>,
    },
    {
      name: <span className="font-weight-bold fs-13">Status</span>,
      selector: (row) => row.status || "inactive",
      sortable: true,
      cell: (row) => (
        <div style={getRowStyle(row)}>
          <SwitchInput
            id={`status-switch-${row.id || row._id}`}
            label=""
            required={false}
            defaultState={row.status === "active"}
            disabled={row.isDeleted}
            onChange={(checked) => {
              if (onStatusChange && !row.isDeleted) {
                onStatusChange(row, checked ? "active" : "inactive");
              }
            }}
            onText="Active"
            offText="Inactive"
            switchColor="#00209F"
            switchOffColor="#ccc"
            fontSize="12px"
          />
        </div>
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">Role</span>,
      selector: (row) => (row.isAdmin ? "Admin" : "User"),
      sortable: true,
      cell: (row) => (
        <div style={getRowStyle(row)}>
          <span
            className={`badge ${row.isAdmin ? "badge-soft-success" : "badge-soft-secondary"
              }`}
            style={{
              backgroundColor: row.isAdmin ? "#e6fff0" : "#f0f0f0",
              color: row.isAdmin ? "#00b341" : "#6c757d",
              padding: "6px 12px",
              fontWeight: "600",
              fontSize: "12px",
              borderRadius: "4px",
              border: `1px solid ${row.isAdmin ? "#b3ffd9" : "#e4e4e4"
                }`,
            }}
          >
            {row.isAdmin ? "Admin" : "User"}
          </span>
        </div>
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">Created At</span>,
      selector: (row) => row.createdAt || row.created_at || "",
      sortable: true,
      cell: (row) => (
        <div style={getRowStyle(row)}>
          {formatDate(row.createdAt || row.created_at)}
        </div>
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">Actions</span>,
      cell: (row) => (
        <div className="d-flex align-items-center justify-content-center gap-2">
          {/* ✏️ Edit */}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (row.isDeleted) return; // Prevent action if deleted
              if (onEditClick) onEditClick(row);
            }}
            title={row.isDeleted ? "Cannot edit deleted user" : "Edit"}
            className={row.isDeleted ? "disabled" : ""}
            style={row.isDeleted ? {
              pointerEvents: 'none',
              opacity: 0.5,
              cursor: 'not-allowed'
            } : {}}
          >
            <i
              className={`ri-edit-2-fill fs-13 p-2 rounded-circle shadow-sm ${row.isDeleted ? "text-muted bg-f1" : "text-primary bg-f1"
                }`}
            />
          </a>

          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (onViewSubscriptions) onViewSubscriptions(row);
            }}
            title="View Subscription Transactions"
          >
            <i className="ri-wallet-3-fill fs-13 text-info p-2 rounded-circle shadow-sm bg-f1" />
          </a>

          {/* 🗑️ Delete */}
          {!row.isAdmin && !row.isDeleted && (
            <>
              <a
                href="#"
                onClick={(event) => {
                  event.preventDefault();
                  setConfirmOpenForId(row.id || row._id);
                }}
                title="Delete"
              >
                <i className="ri-delete-bin-7-fill fs-13 text-danger p-2 rounded-circle shadow-sm bg-f1" />
              </a>

              {confirmOpenForId === (row.id || row._id) && (
                <ConfirmPopup
                  message="Are you sure you want to delete this user?"
                  setConfirmOpen={() => setConfirmOpenForId(null)}
                  onConfirm={(event) => {
                    if (onDeleteClick) {
                      onDeleteClick(event, row.id || row._id);
                    }
                    setConfirmOpenForId(null);
                  }}
                />
              )}
            </>
          )}

          {/* ♻️ Restore */}
          {row.isDeleted && (
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                toast.success('Restore feature is not implemented yet. Please wait!');
                if (onRestoreClick) onRestoreClick(row);
              }}
              title="Restore User"
            >
              <i className="ri-refresh-line fs-13 text-success p-2 rounded-circle shadow-sm bg-f1" />
            </a>
          )}
        </div>
      ),
    },
  ];
};
